import { createAsyncAction, createReducer } from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriptions'
import { AxiosError } from 'axios'
import { subscribeListDTO } from '../lib/api/types';

export type getResultsDTO = {
  listId: string,
  token: string,
}
export type getResultsState = {
  data: getResultsPayloadType
  loading : boolean
  error: boolean
  errorData?: AxiosError
  status?: 'request'|'success'|'failure'
}

export type getResultsPayloadType = {
  listId: number
  listName: string
  modifyUrl?: string
  status?: string
  emailAddress?: string
}

export const getResults = createAsyncAction(
  'GET_RESULTS',
  'GET_RESULTS_SUCCESS',
  'GET_RESULTS_FAILURE',
)<getResultsDTO, any, AxiosError>();

type getResultsAction = ReturnType<typeof getResults.request>

const initialState: getResultsState = {
  data:{
    listId: 0,
    listName:'',
    emailAddress:''
  },
  loading:true,
  error:false,
  status:'request'
}

export function* getResultsSaga(action:getResultsAction):Generator{
  try {
    const response:any = yield call(
      api.getResult,
      action.payload
    )
    yield put(getResults.success(response.data))
  } catch (e) {
    yield put(getResults.failure(e))
  }
}

export function* resultsSaga(){
  yield all([takeEvery(getResults.request, getResultsSaga)])
}

export const subscriptionResults = createReducer<
  getResultsState,
  ReturnType<typeof getResults.request>|
  ReturnType<typeof getResults.success>|
  ReturnType<typeof getResults.failure>
>(initialState)
  .handleAction(
    getResults.request,
    (state:getResultsState, action:{payload: getResultsDTO}
      )=>({
        ...state,
        loading:true,
        error:false,
        status:'request'
      })
  ).handleAction(
    getResults.success,
    (state:getResultsState, action:{payload: getResultsPayloadType}
      )=>({
        ...state,
        data:action.payload,
        loading:false,
        status:'success',
      })
  ).handleAction(
    getResults.failure,
    (state:getResultsState, action:{payload: AxiosError}
      )=>({
        ...state,
        loading:false,
        error:true,
        errorData:action.payload,
        status:'failure'
      })
  )

  export default subscriptionResults